import { render, staticRenderFns } from "./EstimateTaskItemTotals.vue?vue&type=template&id=74a65a83&"
import script from "./EstimateTaskItemTotals.vue?vue&type=script&lang=js&"
export * from "./EstimateTaskItemTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports